import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ImportsModule } from '../../../shared/imports.module';
import { Usuario, Rol, Sociedad } from '../../../shared/models';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RolesService } from '../../../shared/services/roles.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { finalize } from 'rxjs';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-roles-update',
  standalone: true,
  imports: [
    ImportsModule, 
    CommonModule, 
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzDatePickerModule,
    NzButtonModule
  ],
  templateUrl: './roles-update.component.html',
  styleUrl: './roles-update.component.scss'
})
export class RolesUpdateComponent implements OnInit {
  @Input() usuario?: Usuario | null;
  
  usuarioForm?: FormGroup;
  roles: Rol[] = [];
  sociedades: Sociedad[] = [];
  loading: boolean = false;

  constructor(private fb: FormBuilder, private rolesService: RolesService, private message: NzMessageService, private cdr: ChangeDetectorRef, private drawerRef: NzDrawerRef) {
  }

  ngOnInit() {
    this.crearFormulario();
    this.obtenerRoles();
    this.obtenerSociedades();
  }

  crearFormulario() {
    this.usuarioForm = this.fb.group({
      id: [ this.usuario?.usuarioId || 0 ],
      rfc: [ null ],
      email: [ this.usuario?.email || '', [Validators.required, Validators.email]],
      rolId: [ this.usuario?.rolId || null, [Validators.required]],
      sociedadId: [ this.usuario?.sociedadId || null, [Validators.required] ],
    });
  }

  obtenerRoles() {
    this.rolesService.obtenerRoles()
    .subscribe({
      next: (data) => {
        this.roles = data?.details as Rol[];
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error al cargar roles:', error);
      }
    });
  }

  obtenerSociedades() {
    this.rolesService.obtenerSociedades()
    .subscribe({
      next: (data) => {
        this.sociedades = data?.details as Sociedad[];
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error al cargar sociedades:', error);
      }
    });
  }

  onSubmit() {
    if (this.usuarioForm?.valid) {
      let formData = this.usuarioForm.getRawValue();
      let FuncionUsuario = ( this.usuario && this.usuario.usuarioId ) ?
        this.rolesService.actualizarUsuario(formData) :
        this.rolesService.insertarUsuario(formData);
      this.loading = true;
      FuncionUsuario
      .pipe(finalize(() => {
        this.loading = false;
        this.cdr.detectChanges()
      }))
        .subscribe({
          next: () => {
            this.message.success('Usuario guardado correctamente');
            this.drawerRef.close(true);
          },
          error: (error) => {
            console.error('Error al guardar usuario:', error);
            this.message.error('Error al guardar usuario');
          }
        });
    } else {
      this.message.error('Por favor, corrige los errores en el formulario antes de enviar.');
      this.usuarioForm?.markAllAsTouched();
    }
  }


  disabledDate = (current: Date): boolean => {
    return current && current < new Date();
  }
}
